import type { AgentTreeView, ChatElement } from '@gitlab-org/tui';
import type { Session } from './session';

export interface SessionView {
  elements: ChatElement[];
  agentTree: AgentTreeView | undefined;
}

/**
 * What the app state renders: the viewed agent's log and the tree that scopes it.
 */
export function projectSessionView(session: Session): SessionView {
  return { elements: [...session.viewElements], agentTree: session.agentTree };
}
